import request from '@meitu/saas-editor-ui/es/request';
import { getTextTemplateWebApiHostName } from '@/utils/request';
import {
    ISaveTextArtParams,
    ISaveTextArtResponse,
    ISaveTextMarkParams,
    ISaveTextMarkResponse,
    ITextArtResponse,
    ITextMarkResponse,
    ITransformTextListResponse,
} from './index.d';

/**
 * 接口 [变形文字素材列表]
 * @docs: https://api-mock.meitu-int.com/project/2110/interface/api/113380
 */
export const fetchTransformTextList = async function () {
    return await request<ITransformTextListResponse>(`/seal_pie_internal/material_list.json`, {
        method: 'GET',
        params: {
            type: 'variant_text',
        },
    });
};

/**
 * 接口 [获取划重点资源]
 * @docs: https://api-mock.meitu-int.com/project/2071/interface/api/180938
 */
export const fetchTextMark = async function (id: string) {
    return await request<ITextMarkResponse>(`${getTextTemplateWebApiHostName()}/highlight_key_point/detail`, {
        method: 'GET',
        params: {
            id,
        },
    });
};

/**
 * 接口 [更新划重点]
 * @docs: https://api-mock.meitu-int.com/project/2071/interface/api/180944
 */
export const updateTextMark = async function (data: ISaveTextMarkParams) {
    return await request<ISaveTextMarkResponse>(`${getTextTemplateWebApiHostName()}/highlight_key_point/update`, {
        method: 'POST',
        data,
    });
};

/**
 * 接口 [创建划重点]
 * @docs: https://api-mock.meitu-int.com/project/2071/interface/api/180942
 */
export const createTextMark = async function (data: ISaveTextMarkParams) {
    return await request<ISaveTextMarkResponse>(`${getTextTemplateWebApiHostName()}/highlight_key_point/create`, {
        method: 'POST',
        data,
    });
};

/**
 * 接口 [获取文字特效资源]
 * @docs: https://api-mock.meitu-int.com/project/2071/interface/api/192798
 */
export const fetchTextArt = async function (id: string) {
    return await request<ITextArtResponse>(`${getTextTemplateWebApiHostName()}/text_effect/detail`, {
        method: 'GET',
        params: {
            id,
        },
    });
};

/**
 * 接口 [更新文字特效]
 * @docs: https://api-mock.meitu-int.com/project/2071/interface/api/192802
 */
export const updateTextArt = async function (data: ISaveTextArtParams) {
    return await request<ISaveTextArtResponse>(`${getTextTemplateWebApiHostName()}/text_effect/update`, {
        method: 'POST',
        data,
    });
};

/**
 * 接口 [创建文字特效]
 * @docs: https://api-mock.meitu-int.com/project/2071/interface/api/192801
 */
export const createTextArt = async function (data: ISaveTextArtParams) {
    return await request<ISaveTextArtResponse>(`${getTextTemplateWebApiHostName()}/text_effect/create`, {
        method: 'POST',
        data,
    });
};
